import type { WireframeVariants } from '@octopus-do/octopus-storybook'

export const wireframesName: Record<WireframeVariants, string> = {
  accordeon: 'title-left-accordion-right',
  accordeon_2: 'accordion-outlined',
  app_store_buttons: 'inline-download-badges-appstore-googleplay',
  articles: '3-col-image-text',
  articles_2: 'inline-image-text-image-text',
  articles_3: '2-col-image-text',
  audio_player: 'audio',
  back: 'arrow-back',
  breadcrumbs: 'breadcrumbs',
  bullet_points: 'bullet-list',
  bullet_points_double: '2-col-bullet-list',
  button: 'button-center',
  calendar: 'calendar',
  cards: 'masonry-grid-cards',
  cards_left: '2-cards-left-1-card-right',
  cards_right: '1-card-left-2-cards-right',
  carousel: 'carousel-3-cards',
  catalog: 'catalog-filter-left-cards-right',
  catalog_2: 'catalog-cards',
  chart: 'chart',
  contact_form: 'contact-form-left-text-button-right',
  cta: 'text-button-center',
  cta_2: 'title-left-text-button-right',
  cta_left: 'text-button-left-image-right',
  cta_right: 'image-left-text-button-right',
  divider: 'divider-line',
  divider_dashed: 'divider-dashed',
  double: '2-col-images',
  download: 'download-file-icon-left-text-right',
  dropdown: 'dropdown',
  error_404: '404-error',
  faq: 'faq-accordion',
  features: 'features-inline-icon-feature-icon-feature',
  features_double: '2-col-icon-feature-left-aligned',
  features_quarter: '4-col-icon-feature-left-aligned',
  features_triple: '3-col-icon-feature-left-aligned',
  features_triple_center: '3-col-icon-feature-center-aligned',
  filter: 'filter',
  footer: 'footer-logo-left-nav-links-right',
  footer_type_2: 'footer-minimal',
  form: 'form-left-text-button-right',
  form_2: 'large-text-input-checklist-button',
  form_3: 'form-wide',
  forward: 'arrow-forward',
  hamburger: 'hamburger-menu-left',
  hamburger_right: 'hamburger-menu-right',
  header: 'header-logo-left-nav-links-right',
  header_type_2: 'header-minimal',
  hero_with_arrows: 'hero-image-carousel',
  hierarchy_1: 'hierarchy-chart-vertical',
  hierarchy_2: 'hierarchy-chart-horizontal',
  image: 'image-left-text-right',
  image_placeholder: 'image-wide',
  image_right: 'text-left-image-right',
  input: 'input-wide',
  inputs: '2-col-input',
  interface_header: 'header-nav-links-left-avatar-right',
  invoice: 'estimate-spreadsheet',
  language: 'language-selector',
  left_button: 'button-left',
  loading: 'loading-effect',
  loading_2: 'loading-progress-bar',
  logos: '4-col-logos',
  map: 'map-wide',
  map_2: 'map-left-text-button-right',
  map_3: 'map-left-text-right',
  messengers: 'messengers-icons',
  mobile_bottom_bar: 'mobile-footer-4-col-icons-links',
  mobile_top_bar: 'mobile-header-arrow-back-left-heading-center',
  newsletter: 'newsletter-subscription-form',
  no_logo_navigation: 'navigation-no-logo',
  pagination: 'pagination-with-arrows',
  pie_chart: 'chart-left-text-right',
  post_thread: 'thread-posts',
  pricing: 'pricing-plans',
  product_card: 'product-card-left-text-buttons-right',
  profile: 'profile-picture-left-text-right',
  qr_code: 'QR-code',
  quote: 'quote',
  radio_buttons: 'radio-buttons-text',
  rating: 'rating-stars',
  right_button: 'button-right',
  searchbar: 'search-bar',
  sign_up: 'sign-up-form',
  slider: 'card-slider-wide',
  social_buttons: 'social-network-icons',
  spacer: 'empty-spacing',
  steps: '3-col-steps-text',
  store_buttons: 'two-buttons-center',
  store_buttons_2: 'two-buttons-left',
  table: 'table-spreadsheet',
  table_2: 'table-outlined',
  table_of_contents: 'table-of-contents',
  table_row: 'spreadsheet-one-row',
  tabs: 'interface-tabs',
  team: 'team-3-col-image-text',
  text: 'text-wide',
  text_and_form: 'form-button-left-text-right',
  text_and_form_2: 'text-left-form-button-right',
  text_and_sidebar_form: 'text-wide-left-form-button-right',
  text_and_video: 'video-left-text-right',
  text_and_video_2: 'text-left-video-right',
  text_double: '2-col-text',
  text_on_image: 'text-center-in-image-wide',
  text_on_image_2: 'text-left-in-image',
  text_on_image_3: '2-col-text-in-image',
  text_quarter: '4-col-text',
  text_triple: '3-col-text',
  timeline: 'timeline-horizontal',
  timeline_2: 'timeline-vertical',
  title: 'title-center',
  title_and_paragraph: 'title-left-text-right',
  title_center: 'title-center',
  title_left: 'title-left',
  todo: 'inline-checklist',
  toggle: 'inline-toggle-list',
  triple: '3-col-images',
  two_column_slider: '2-col-slider',
  upload_button: 'file-upload-block',
  video: 'video-wide',
  wide: 'image-wide',
}
